import { LinearProgress, linearProgressClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LinearProgressStyled = styled(LinearProgress)(({ theme }) => ({
  [`&.${linearProgressClasses.colorPrimary}`]: { backgroundColor: theme.palette.progress.linear.primary },
  [`& > .${linearProgressClasses.barColorPrimary}`]: { backgroundColor: theme.palette.progress.linear.secondary },
  width: '100%',
  marginBottom: '20px',
  marginTop: '20px',
}));
